import _ from "lodash"
import jsonLogic from "json-logic-js"

const preconditionTypes = {
    DISABLE: "DISABLE",
    HIDDEN: "HIDDEN",
    VALIDATE: "VALIDATE",
}

const getConditionsForOptionType = (containerOrWidget, optionType) => {
    const preconditions =
        containerOrWidget.precondition?.map((entry) => entry.origin) ?? []
    const conditions =
        preconditions
            .filter((precondition) => precondition?.optionType === optionType)
            .map((entry) => entry.condition) ?? []
    return conditions
}

const extractVars = (logic) => {
    let vars = []

    const findVars = (obj) => {
        if (_.has(obj, "var")) {
            const v = obj.var
            if (_.isArray(v)) {
                vars.push(v[0])
            } else if (_.isString(v)) {
                vars.push(v)
            }
        }

        if (_.isObject(obj) && !_.isString(obj)) {
            _.forEach(obj, findVars)
        }
    }

    findVars(logic)
    return _.uniq(vars)
}

const validateConditions = (conditions, getDataFromPointer) => {
    const result = conditions.map((condition) => {
        const conditionVars = extractVars(condition)
        const dataForCondition = conditionVars.reduce((acc, varName) => {
            acc[varName] = getDataFromPointer(varName);
            return acc;
        }, {})
        return jsonLogic.apply(condition, dataForCondition);
    })

    return result.some((entry) => !entry);
}

export const checkConditionsForDisabled = (
    containerOrWidget,
    getDataFromPointer,
) => {
    const conditions = getConditionsForOptionType(
        containerOrWidget,
        preconditionTypes.DISABLE,
    )
    if (conditions.length) {
        return validateConditions(conditions, getDataFromPointer)
    }
    return false
}

export const checkConditionsForHidden = (
    containerOrWidget,
    getDataFromPointer,
) => {
    const conditions = getConditionsForOptionType(
        containerOrWidget,
        preconditionTypes.HIDDEN,
    )
    if (conditions.length) {
        return !validateConditions(conditions, getDataFromPointer)
    }
    return false
}

export const checkVisibility = (content, getDataFromPointer) => {
    const displayPointer = content.displayPointer?.origin
        ? content.displayPointer?.origin.pointer
        : content.displayPointer
    return displayPointer && content?.displayValue
        ? "" + getDataFromPointer(displayPointer) === content.displayValue
        : true
}
